import React from 'react';
import PropTypes from 'prop-types';
import {
  CategoryLabel2,
  DetailsContent,
  TitleContainer,
  DisabledLabel,
  StyledDivider,
  DateAndUserInfo
} from './styled';
import { Col, Row, Tooltip } from 'antd';
import { convertISOToDateTimeWithoutSeconds } from '../../../util/timezone';
import { getCategoryLabel } from '../../common/utils';

const CombinationDetails = ({ segmentLiveSets }) => {
  const { createdAt, createdBy, categories, combinations } = segmentLiveSets;

  const renderCategoryValue = (entries, currentCategory) => {
    const value = entries.find(
      ({ category }) => category === currentCategory
    )?.value;

    return (
      <Tooltip title={value}>
        <DisabledLabel>{value}</DisabledLabel>
      </Tooltip>
    );
  };

  return (
    <>
      <TitleContainer>
        <div>Categories and Details</div>
      </TitleContainer>
      <DetailsContent>
        <Row gutter={[32, 8]}>
          <Col span={8}>
            {categories?.[0] && (
              <CategoryLabel2>{getCategoryLabel(categories[0])}</CategoryLabel2>
            )}
          </Col>
          <Col span={8}>
            {categories?.[1] && (
              <CategoryLabel2>{getCategoryLabel(categories[1])}</CategoryLabel2>
            )}
          </Col>
          <Col span={8}>
            {categories?.[2] && (
              <CategoryLabel2>{getCategoryLabel(categories[2])}</CategoryLabel2>
            )}
          </Col>
          {combinations?.map(({ entries }, index) => (
            <React.Fragment key={index}>
              <Col span={8}>
                {categories?.[0] && renderCategoryValue(entries, categories[0])}
              </Col>
              <Col span={8}>
                {categories?.[1] && renderCategoryValue(entries, categories[1])}
              </Col>
              <Col span={8}>
                {categories?.[2] && renderCategoryValue(entries, categories[2])}
              </Col>
              {combinations?.length - 1 !== index && (
                <Col span={24}>
                  <StyledDivider
                    width={`${(categories?.length / 3) * 100 || 100}%`}
                  />
                </Col>
              )}
            </React.Fragment>
          ))}
        </Row>
        {createdAt && createdBy && (
          <DateAndUserInfo>
            Last Modified at "{convertISOToDateTimeWithoutSeconds(createdAt)}"
            by "{createdBy || '-'}"
          </DateAndUserInfo>
        )}
      </DetailsContent>
    </>
  );
};

CombinationDetails.propTypes = {
  segmentLiveSets: PropTypes.object
};

export default CombinationDetails;
